export default __webpack_public_path__ + "static/media/LandingPageMockExams.87c5eb24.jpg";